import styled from "styled-components";
import { fontSizeMap as textFontSizeMap } from "../Text/Text.style.js";
import { ITheme } from "../Theme/Theme.types.js";
import { DefaultTagProps, TagColors, TagProps } from "./Tag.types.js";

const getTagColor = (color: TagColors, theme: ITheme, filled?: boolean): string => {
    if (color === "title_active") return theme.grayscale[100];
    if (color === "default") return theme.grayscale[70];
    if (filled) return "white";
    return theme.colors[color][110];
};

const getTagBackground = (color: TagColors, theme: ITheme, filled?: boolean): string => {
    if (color === "title_active") return theme.grayscale[50];
    if (color === "default") return theme.grayscale[30];
    const themeColor = theme.colors[color];
    if (filled) return themeColor[100];
    return themeColor[10];
};

const getBorderRadius = (theme: ITheme, shape?: "square" | "rounded", filled?: boolean): string => {
    if (shape === "square") return theme.radius.xxs;
    if (filled) return theme.radius.xxl;
    return theme.radius.xs;
};

export const StyledTag = styled.div<TagProps & DefaultTagProps>`
    display: inline-flex;
    align-items: center;
    padding: ${(props) => `${props.theme.spacing["8"]} ${props.theme.spacing["16"]}`};
    border-radius: ${(props) => getBorderRadius(props.theme, props.shape, props.filled)};
    color: ${(props) => getTagColor(props.color, props.theme, props.filled)};
    background-color: ${(props) => getTagBackground(props.color, props.theme, props.filled)};
    font-size: ${(props) => props.theme.rem(textFontSizeMap["x-small"])};
    cursor: default;
    white-space: nowrap;
    gap: ${({ theme }) => theme.spacing["8"]};

    & svg {
        cursor: inherit;
    }
`;
